/*!
 * Chieh-Han Chang v20240717
 * Copyright 2019-2024
 * Licensed under Tonghe 2024 Tonghe Marketing Co.,Ltd .
 */


var whois = "We Are 通和行銷！"

//當前視窗寬度為wdth
wdth = $(window).width()
$(window).resize(function() {
    wdth = $(window).width()
})

//設定響應式斷點
function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
}

mediawdth_desktop = 1270 - getScrollbarWidth()
mediawdth_tablet = 768 - getScrollbarWidth()


$(document).ready(function() {

    // Run after webpage load finished
    searchbar()
    backtotop()
    menutogglecontrol()
    Navbartoggle()
    counterControl() //.counter
    Textnumber() // 字數裁減, 對象為.js-textnumber, 使用data-textnumber=""
    Tenpercentile() //數字處理千分位, 對象為.js-tenpercentile
    CommonDateFunc() //月份數字轉換英文文字, 日的數字為個位數時補一個0
    NavbarStyle() //整個navbar在捲動一定距離時給予特別樣式
    NavbarCurrentPageStyle() //當前頁面的主題在navbar上的對應標題顯示另外樣式
    Swiper_initial() //Swiper初始化
    tabboxControl(true) //.tabbox
    socialShareButtonControl() //社群分享按鈕
    copyrightYear() //版權年份自動填入
    dropdownControl() //dropdown通用展開縮合 
    safariHacks() //解決手機版safari & chrome 在100vh會包含網址列的問題
    SelectCountryLoad() //下拉選單載入國家選項

    // reload when window resizes through the breakpoints
    // WebReload([mediawdth_tablet, mediawdth_desktop])

    // niceScroll_initial()
    policyblock()

    // Custom element setting
    // style_checkbox();
    checkboxGiveId()
    radioGiveId()
    style_select_init() //custom select style
    style_input()
    bubbleBtn('btn-bubble', 'js-btn-bubble--hover', 'btn-bubble__circle') //按鈕hover時,隨著滑鼠進入方向產生特效,填入按鈕class,按鈕hover的class名稱,產生特效的元件名稱

    // For RWD JS running & specific page JS running
    RUNFUNCRWD()
    JSPAGEcontrol() //note:run only once

    // new WOW().init();
    // wow = new WOW({
    //     boxClass: "wow", // default
    //     animateClass: "animated", // default
    //     offset: 160, // default
    //     mobile: true, // default
    //     live: true, // default
    // })
    // wow.init()

    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1200, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

    });

    // 列印hack
    window.addEventListener('beforeprint', function() {
        //避免列印時，每一頁都有網站導覽列，會遮到列印的內容
        $('.site-nav').css('position', 'relative')
        $('.header__blank-space').hide()

        //因網頁列印時，會以media 794px檢視，所以需要重新設定container寬度，使列印的頁面滿版
        $('.container').css('width', '100%')
        $(window).on('focus', function() {
            $('.site-nav').attr('style', '')
            $('.header__blank-space').show()
            $('.container').attr('style', '')
        })
    })
})

function WebReload(reloadpoints) {
    var firstwdth = $(window).width()
    reloadpoints.forEach(function(breakpoint) {
        $(window).resize(function() {
            if (firstwdth >= breakpoint) {
                // console.log(breakpoint)
                $(window).width() <= breakpoint ? location.reload() : ''
            } else {
                $(window).width() > breakpoint ? location.reload() : ''
            }
        })
    })
}

//RUN specific function when switch to desktop or mobile device
//screenmode=0代表已調整為手機版  =1代表已調整為平板版  =2代表已調整為電腦版
function RUNFUNCRWD() {

    if (wdth < mediawdth_desktop) {
        screenmode = 2
    } else {
        screenmode = 0
    }

    var RWD_function = (() => {
        if (wdth < mediawdth_tablet) {
            if (screenmode != 0) {
                screenheight = $(window).innerHeight()

                //調整成手機版後要run的func

                $(".opentoggle").siblings("ul").slideUp()
                $(".sticker-triangle-active").removeClass("sticker-triangle-active")

                NavbarStyle()

                screenmode = 0
                console.log("JS程式-已執行運行手機版")
            }
        } else if (wdth < mediawdth_desktop) {
            if (screenmode != 1) {
                screenheight = $(window).innerHeight()

                //調整成平板版後要run的func

                $(".opentoggle").siblings("ul").slideUp()
                $(".sticker-triangle-active").removeClass("sticker-triangle-active")


                NavbarStyle()
                screenmode = 1
                console.log("JS程式-已執行運行平板版")
            }
        } else {
            if (screenmode != 2) {
                screenheight = $(window).innerHeight()

                //調整成電腦版後要run的func
                $(".opentoggle").siblings("ul").stop().height('auto').show()
                $(".navitem-group").removeClass("js-navitem-group--open")
                $(".screenmask").removeClass("screenmask--active")
                $(".wrapper-searchwindow").removeClass("is-softshow")
                $(".menu-toggle").find("span").removeClass("menu-toggle__span--active")
                $(".navhead ul").removeClass("h100")
                $(".navhead-a-active").removeClass("navhead-a-active")
                $(".sticker-triangle-active").removeClass("sticker-triangle-active")

                NavbarStyle()

                screenmode = 2
                console.log("JS程式-已執行運行電腦版")
            }
        }
    })

    RWD_function()
    $(window).resize(function() {
        RWD_function()
    })

}

function JSPAGEcontrol() {

    switch ($currentpage) {

        case 'INDEX':


            // $("#paroller").paroller({
            //     factor: 0.5,
            //     factorXs: 0.2,
            //     factorSm: 0.3,
            //     type: 'background',
            //     direction: 'vertical'
            //     transition: 'transform 0.1s ease'
            // });

            // gsap.to('.element',{
            //     scrollTrigger:{
            //         trigger: '.page',
            //         start: "top bottom",
            //         end: "bottom bottom",
            //         scrub: 1
            //     },
            //     scale: '2'
            // })

            productboxIndexBorderAnimation() //產品卡片邊框動畫

            ScrollReachRun('.aboutarea', '-200px 0px -200px 0px', {
                    repeat: false,
                    mirror: true,
                    individual: true,
                },
                (that) => {
                    $(that).addClass('js-aboutarea--animated')
                        // console.log('進入作用範圍')
                },
                (that) => {
                    $(that).removeClass('js-aboutarea--animated')
                        // console.log('離開作用範圍')
                })

            ScrollReachRun('.productsarea', '-200px 0px -200px 0px', {
                    repeat: false,
                    mirror: true,
                    individual: true,
                },
                (that) => {
                    $(that).addClass('js-productsarea--animated')
                    swiper_productarea.autoplay.start();
                        // console.log('進入作用範圍')
                },
                (that) => {
                    $(that).removeClass('js-productsarea--animated')
                        // console.log('離開作用範圍')
                })

            ScrollReachRun('.newsarea', '-200px 0px -200px 0px', {
                    repeat: false,
                    mirror: true,
                    individual: true,
                },
                (that) => {
                    $(that).addClass('js-newsarea--animated')
                        // console.log('進入作用範圍')
                },
                (that) => {
                    $(that).removeClass('js-newsarea--animated')
                        // console.log('離開作用範圍')
                })

            ScrollReachRun('.contactarea', '-200px 0px -200px 0px', {
                    repeat: false,
                    mirror: true,
                    individual: true,
                },
                (that) => {
                    $(that).addClass('js-contactarea--animated')
                        // console.log('進入作用範圍')
                },
                (that) => {
                    $(that).removeClass('js-contactarea--animated')
                        // console.log('離開作用範圍')
                })


            break;

        case 'ABOUT':
            break;

        case 'MEMBER':
            inputTYPEcheck()
            break;

        case 'PRODUCTS':
            break;

        case 'PRODUCTSDETAIL':

            //blowup.js 放大鏡功能
            // $('.swiper-nail img').each(function(){
            //     $(this).blowup({
            //         scale: 3,
            //         cursor: false
            //     })
            // })

            break;

        case 'NEWS':
            // textlengthcut('.newsbox', 20, 40, 80) //文字太長裁減. classname, sm時字數, md時字數, lg時字數
            break;

        case 'INQUIRY':
            break;

        case 'FAQ':
            faqboxcontrol(true) //if參數為true: 點擊項外都關閉
            break;

        case 'GUIDELINE':
            faqboxcontrol(true) //if參數為true: 點擊項外都關閉
            break;
    }

}

// 點擊hamburger bar後
function menutogglecontrol() {
    $(".menu-toggle").click(function() {
        console.log("點了menu-toggle")
        $(".navitem-group").toggleClass("js-navitem-group--open")
        $(this).find("span").toggleClass("menu-toggle__span--active")

        // $header.removeClass("topbar--mobile-shrink");

        if ($(".navitem-group").hasClass("js-navitem-group--open")) {
            $(".screenmask").addClass("screenmask--active")
        } else if ($(".wrapper-searchwindow").hasClass("is-softshow")) {} else {
            $(".screenmask").removeClass("screenmask--active")
        }
    })
    $(".screenmask").click(function() {
        $(this).removeClass("screenmask--active")
        $(".navitem-group").removeClass("js-navitem-group--open")
        $(".menu-toggle").find("span").removeClass("menu-toggle__span--active")
        $(".wrapper-searchwindow").removeClass("is-softshow")
    })
}

//Navbar 次選單opentoggle
function Navbartoggle() {
    $(".opentoggle").click(function() {
        // 展開點的該層
        // $(this).siblings('ul').toggleClass('h100');
        $(this).siblings("ul").slideToggle()

        // 先移除其他層的"激活"樣式
        // $(this).parent().siblings('li').find('ul').removeClass('h100');
        $(this).parent().siblings("li").find("ul").slideUp()
        $(this).parent().siblings("li").removeClass("navhead-active")
        $(this).parent().siblings("li").find('.sticker-triangle').removeClass("sticker-triangle-active")
        $(this).parent().siblings("li").find('a').removeClass("navhead-a-active")
        $(this).parent().siblings("li").removeClass("sub-navhead-active")

        $(this).siblings('ul').find('li .sticker-triangle').removeClass("sub-navhead__sticker-triangle-active")
        $(this).siblings('ul').find('li a').removeClass("sub-navhead-a-active")
        $(this).siblings('ul').find('li ').removeClass("sub-navhead-active")
        $(this).siblings("ul").find('ul').slideUp()

        $(this).parent().siblings("li").find('.sticker-triangle').removeClass("sub-navhead__sticker-triangle-active")
        $(this).parent().siblings("li").find('a').removeClass("sub-navhead-a-active")

        // 檢查是在哪一層選單,激活相關樣式
        if ($(this).parent().hasClass("sub-navhead")) {
            $(this).find(".sticker-triangle").toggleClass("sub-navhead__sticker-triangle-active")
            $(this).parent().toggleClass("sub-navhead-active")
            $(this).siblings("a").toggleClass("sub-navhead-a-active")
        } else {
            $(this).find(".sticker-triangle").toggleClass("sticker-triangle-active")
            $(this).parent().toggleClass("navhead-active")
            $(this).siblings("a").toggleClass("navhead-a-active")
        }
    })
}

// Searchbar
function searchbar() {

    var $searchOpenBtn = $("#js-searchBtn")

    $searchOpenBtn.click(function() {
        if ($(".wrapper-searchwindow").hasClass("is-softshow")) {
            $(".wrapper-searchwindow").removeClass("is-softshow")
            if ($(".navitem-group").hasClass("js-navitem-group--open")) {} else {
                $(".screenmask").removeClass("screenmask--active")
            }
        } else {
            $(".screenmask").addClass("screenmask--active")
            $(".wrapper-searchwindow").addClass("is-softshow")
            setTimeout(function() {
                // 因為有visibility: hidden, 所以需要等一會兒後再focus
                $('.wrapper-searchwindow .searchbar__input').focus();
            }, 100);
        }
    })
    $(".wrapper-searchwindow__searchclose").click(function() {
        $(".wrapper-searchwindow").removeClass("is-softshow")
        if ($(".navitem-group").hasClass("js-navitem-group--open")) {} else {
            $(".screenmask").removeClass("screenmask--active")
        }
    })
}

//  backtotop, transfer the window to topside
function backtotop() {
    if ($("#back-to-top").length) {

        backToTop = function(scrollTrigger, scrollTrigger_bottom) {
            var scrollTop = $(window).scrollTop()
            if (scrollTop > scrollTrigger) {
                $("#back-to-top").addClass("is-softshow")
            } else {
                $("#back-to-top").removeClass("is-softshow")
            }

            if (scrollTop > scrollTrigger_bottom) {
                $("#back-to-top").addClass("backTotop--fixedAtFooter")
            } else {
                $("#back-to-top").removeClass("backTotop--fixedAtFooter")
            }
        }

        backToTop()


        $(window).on("scroll", function() {
            var scrollTrigger = 100 // px
            var scrollTrigger_bottom = $(document).innerHeight() - $(window).outerHeight() - $('.footer').innerHeight()
            backToTop(scrollTrigger, scrollTrigger_bottom)
        })

        $("#back-to-top").on("click", function(e) {
            e.preventDefault()
            $("html,body").animate({
                    scrollTop: 0,
                },
                700,
                "swing"
            )
        })

    }
}

//News context too long will be cut
function textlengthcut(classname, len_sm, len_md, len_lg) {

    $(classname).each(function() {
        if ($(this).attr('title') == undefined) {
            $(this).attr('title', $(this).text())
        }
    })

    docutting = function() {
        $(classname).each(function() {
            if (wdth >= mediawdth_desktop) {
                if ($(this).attr('title').length > len_lg) {
                    var text = $(this).attr('title').substring(0, len_lg) + '...'
                    $(this).text(text)
                }
            } else if (wdth >= mediawdth_tablet && wdth < mediawdth_desktop) {
                if ($(this).attr('title').length > len_md) {
                    var text = $(this).attr('title').substring(0, len_md) + '...'
                    $(this).text(text)
                }
            } else {
                if ($(this).attr('title').length > len_sm) {
                    var text = $(this).attr('title').substring(0, len_sm) + '...'
                    $(this).text(text)
                }
            }
        })
    }

    docutting()

    $(window).resize(function() {
        docutting()
    })

}

//Slick initial
function Slick_initial() {

    switch ($currentpage) {
        case 'INDEX':
            $(".slick-productarea").slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                pauseOnFocus: false,
                draggable: false,
                arrows: false,
                dots: true,
                dotsClass: "slick-dots",
                //has customized at slick-theme.css
                cssEase: "ease",
                responsive: [{
                        breakpoint: 1270,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            draggable: true,
                            pauseOnHover: false,
                            pauseOnFocus: false,
                            centerMode: true,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: false,
                        },
                    },
                ],
            })
            break;
    }
}

//Swiper initial
function Swiper_initial() {
    switch ($currentpage) {
        case 'INDEX':
            const swiper_jumbotron = new Swiper('.swiper-jumbotron', {
                direction: 'horizontal',
                loop: true,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 8,
                reverseDirection: false,
                stopOnLastSlide: false,
                speed: 1000,
                effect: 'fade', //若用lazy preload, 必須用slide
                fadeEffect: {
                    crossFade: true,
                },
                lazyPreloadPrevNext: 0,
                lazyPreloaderClass: 'swiper-lazy-preloader',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false, //Set to false and autoplay will not be disabled after user interactions (swipes), it will be restarted every time after interaction
                    pauseOnMouseEnter: false, //When enabled autoplay will be paused on mouse enter over Swiper container. If disableOnInteraction is also enabled, it will stop autoplay instead of pause
                },
                pagination: {
                    el: '.swiper-jumbotron .swiper-pagination',
                    clickable: true
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    },
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    },
                    // when window width is >= 640px
                    1270: {
                        slidesPerView: 1,
                        spaceBetween: 8,
                    }
                },
                // scrollbar: {
                //     el: '.swiper-scrollbar',
                // },
                on: {
                    init: function() {
                        const activeSlide = this.slides[this.activeIndex]
                        $(activeSlide).addClass('swiper-slide-transitionEnd')
                            // console.log('transitionEnd')
                    },
                    transitionEnd: function() {
                        const activeSlide = this.slides[this.activeIndex]
                        $('.swiper-jumbotron .swiper-slide').removeClass('swiper-slide-transitionEnd')
                        $(activeSlide).addClass('swiper-slide-transitionEnd')
                            // console.log('transitionEnd')
                    }
                }
            });

            swiper_productarea = new Swiper('.swiper-productarea', {
                direction: 'horizontal',
                loop: true,
                allowTouchMove: true,
                slidesPerView: 2,
                spaceBetween: 10,
                reverseDirection: false,
                stopOnLastSlide: false,
                speed: 1000,
                effect: 'slide', //若用lazy preload, 必須用slide
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true, //Set to false and autoplay will not be disabled after user interactions (swipes), it will be restarted every time after interaction
                    pauseOnMouseEnter: false, //When enabled autoplay will be paused on mouse enter over Swiper container. If disableOnInteraction is also enabled, it will stop autoplay instead of pause
                },
                pagination: {
                    el: '.productsarea .swiper-pagination',
                    clickable: true
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                breakpoints: {
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    // when window width is >= 640px
                    1270: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    }
                },
            });

            swiper_productarea.autoplay.stop();

            const swiper_newsarea = new Swiper('.swiper-newsarea', {
                direction: 'horizontal',
                loop: true,
                allowTouchMove: true,
                slidesPerView: 1,
                spaceBetween: 10,
                reverseDirection: false,
                stopOnLastSlide: false,
                speed: 1000,
                effect: 'slide', //若用lazy preload, 必須用slide
                // autoplay: {
                //     delay: 3000,
                //     disableOnInteraction: false, //Set to false and autoplay will not be disabled after user interactions (swipes), it will be restarted every time after interaction
                //     pauseOnMouseEnter: false, //When enabled autoplay will be paused on mouse enter over Swiper container. If disableOnInteraction is also enabled, it will stop autoplay instead of pause
                // },
                navigation: {
                    nextEl: '.newsarea .swiper-button-next',
                    prevEl: '.newsarea .swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    // when window width is >= 640px
                    1270: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                    1500: {
                        slidesPerView: 3,
                        spaceBetween: 90,
                    }
                },
            });
            break;

        case 'PRODUCTSDETAIL':
            const swiper_thumb = new Swiper('.swiper-thumb', {
                direction: 'horizontal',
                allowTouchMove: true, //在thumb這項若設false, 游標點擊.swiper-slide有時會不起作用
                loop: false,
                spaceBetween: 8,
                slidesPerView: 4,
                speed: 1000,
                effect: 'slide',
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    nextEl: '.swiper-thumb-btnouter .swiper-button-next',
                    prevEl: '.swiper-thumb-btnouter .swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 480px
                    768: {
                        direction: 'horizontal',
                        slidesPerView: 4,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    1270: {
                        direction: 'horizontal',
                        slidesPerView: 4,
                        spaceBetween: 8
                    }
                }
            });
            const swiper_nail = new Swiper('.swiper-nail', {
                direction: 'horizontal',
                allowTouchMove: true,
                loop: false,
                slidesPerView: 1,
                speed: 1000,
                effect: 'slide',
                thumbs: {
                    swiper: swiper_thumb
                },
                breakpoints: {
                    // when window width is >= 480px
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 30
                    },
                    // when window width is >= 640px
                    1270: {
                        slidesPerView: 1,
                        spaceBetween: 2
                    }
                }
            });

            break;
    }
}

// Flexslider initial
function Flexslider_initial() {
    if ($(".flexslider").length > 0) {
        //>0，避免找不到執行失敗而導致後續js無法執行
        $(".flexslider").flexslider({
            animation: "slide",
            controlNav: "thumbnails",
            directionNav: false,
        })
    }
}

//Sitenav shrink when scrolldown
function NavbarStyle() {
    $header = $(".main-menu")

    if (wdth < mediawdth_desktop) {
        $header.removeClass("main-menu--shrink")
    } else {
        $header.removeClass("main-menu--mobile-shrink")
    }

    $(window).on("scroll", function() {
        var scrollDistance = $(window).scrollTop()
            // 手機版navbar點開時,即使捲動 main-menu也不會縮小
        if ($(".navitem-group").hasClass("js-navitem-group--open")) {} else {
            if (wdth < mediawdth_desktop) {
                if (scrollDistance > 100) {
                    $header.addClass("main-menu--mobile-shrink")
                } else {
                    $header.removeClass("main-menu--mobile-shrink")
                }
            } else {
                if (scrollDistance > 100) {
                    $header.addClass("main-menu--shrink")
                } else {
                    $header.removeClass("main-menu--shrink")
                }
            }
        }
    })
}

function style_checkbox() {
    $('.inquirylist__item').click(function() {
        if ($(this).find('input').prop('checked') == true) {
            $(this).removeClass('bg-color--gray')
            $(this).addClass('bg-color--primary')
            $(this).removeClass('color--contentblack')
            $(this).addClass('color--white')
            $(this).find('.inquirylist__checkbox::before').css('visibility', 'visible')
            $(this).find('.inquirylist__checkbox::after').css('visibility', 'visible')
        } else {
            $(this).removeClass('bg-color--primary')
            $(this).addClass('bg-color--gray')
            $(this).removeClass('color--white')
            $(this).addClass('color--contentblack')
        }
    })
}


//Control the .faqbox shrink and stretch
function faqboxcontrol(allsw) {

    $('.faqbox__head').click(function() {
        if ($(this).parent('.faqbox').hasClass('faqbox--active')) {
            //點擊的項目移除active, 點擊的項目答案關閉
            $(this).parent('.faqbox').removeClass('faqbox--active')
            $(this).siblings('.faqbox__ans').slideUp()
        } else {
            if (allsw === true) {
                //所有移除active, 答案關閉
                $('.faqbox').removeClass('faqbox--active')
                $('.faqbox__head').siblings('.faqbox__ans').slideUp()
            }

            //點擊的項目新增active, 點擊的項目答案打開
            $(this).parent('.faqbox').addClass('faqbox--active')
            $(this).siblings('.faqbox__ans').slideDown()
        }
    })

}

//自動為input[type="checkbox"]的id及下一個label的for 冠上對應編號  
function checkboxGiveId() {
    var id = 0
    $('input[type="checkbox"]').each(function() {
        $(this).attr('id', 'c' + id)
        $(this).next('label').attr('for', 'c' + id)
        id++
    })
}

//自動為input[type="radio"]的id及下一個label的for 冠上對應編號  
function radioGiveId() {
    var id = 0
    $('input[type="radio"]').each(function() {
        $(this).attr('id', 'r' + id)
        $(this).next('label').attr('for', 'r' + id)
        id++
    })
}

//抓取並執行客製化select
function style_select_init() {
    $(".js-slt-styleoutter").each(function(i) {
        var selectName = "customSelect-" + (i + 1)
        $(this).attr("id", selectName)
        style_select(selectName)
    })
}

//執行客製化select
function style_select(custumSelect) {
    var custumSelect = "#" + custumSelect
    $(custumSelect).find($(".slt-style").hide())
    $(custumSelect).find(".slt-style").css('opacity', '1')
    var select_totalnum = $(custumSelect)
        .find(".slt-style")
        .find(".slt-style__option").length
    var j = 0 // id初始值
    var idArrar = []
    var is_showChange = $(custumSelect).data('show-change') //點擊option後 show的文字是否改變
    if ($(custumSelect).find(".slt-style-show").html() == '') {
        $(custumSelect)
            .find(".slt-style-show")
            .html($(custumSelect).find(".slt-style__option").eq(0).html())
    }

    // 為個別__option建立data-mother-id序號
    $(custumSelect).find('.slt-style__option').each(function(i) {
        $(this).attr('data-mother-id', i)
    })

    // 將個別__option的data-value傳給select裡的option
    $(custumSelect)
        .find(".slt-style__option")
        .each(function() {
            idArrar[j] = $(this).attr("data-value")
            j++
        })

    //建立option
    for (let i = 0; i < select_totalnum; i++) {
        $(custumSelect).find(".slt-style").siblings('select').append('<option value="' + idArrar[i] + '"data-child-id="' + i + '">' + idArrar[i] + "</option>")
    }

    // 在第一位添增一個valer為空的選項，使該select預設選項為空值
    $(custumSelect).find(".slt-style").siblings('select').prepend('<option value="" selected></option>')


    //點擊show之後做的事
    $(custumSelect)
        .find(".slt-style-show")
        .click(function() {
            if ($(this).siblings('.slt-style').hasClass('slt-style--opened')) {
                //點擊,收起完成後移除.slt-style--opened
                $(this).siblings('.slt-style').slideUp(300, function() {
                    $(this).removeClass('slt-style--opened')
                }).siblings(".slt-styleoutter__arrow").removeClass("is-upside-down--top50")
            } else {
                //點擊,開啟完成後增加.slt-style--opened
                $(this).siblings('.slt-style').slideDown(300, function() {
                    $(this).addClass('slt-style--opened')
                }).siblings(".slt-styleoutter__arrow").addClass("is-upside-down--top50")
            }
        })

    //點擊客製選項option做的事
    $(custumSelect)
        .find(".slt-style__option")
        .click(function() {
            $(this).parent().slideToggle()
            $(custumSelect)
                .find(".slt-styleoutter__arrow")
                .toggleClass("is-upside-down--top50")
            var select_html = $(this).html()
            var select_id = $(this).attr("data-mother-id")
            if (is_showChange !== false) {
                $(custumSelect).find(".slt-style-show").html(select_html)
            }
            $(custumSelect)
                .find(".slt-style")
                .siblings('select')
                .children()
                .removeAttr("selected", "")
            $(custumSelect)
                .find(".slt-style")
                .siblings('select')
                .children()
                .each(function() {
                    if ($(this).attr("data-child-id") == select_id) {
                        $(this).attr("selected", "")
                    }
                })
            $(custumSelect).find(".slt-style").siblings('select').change()
        })

    // 搜尋功能
    $(custumSelect)
        .find(".slt-style__search .slt-style__search-input").keyup(function() {
            var keyword = $(this).val().toLowerCase(); // 取得輸入的關鍵字並轉小寫

            // 尋找所有選項
            $(this).closest('.slt-style').find('.slt-style__option').each(function() {
                var optionText = $(this).text().toLowerCase(); // 取得選項文字並轉小寫
                // 檢查選項文字是否包含關鍵字
                if (optionText.indexOf(keyword) > -1) {
                    $(this).show(); // 包含關鍵字則顯示
                } else {
                    $(this).hide(); // 不包含關鍵字則隱藏  
                }
            });
        })

    $('body').click(function(e) {
        // 檢查點擊的目標為.js-slt-styleoutter這個元件，且選單本來就是展開時，就不收起選單。(是為了A選單開啟時，點擊其他的選單也要收起A選單。但若是點擊非選單的地方也要收起選單)
        if ($(e.target).closest('.js-slt-styleoutter').length && $(e.target).closest('.slt-style').hasClass('slt-style--opened')) {} else {
            $('.slt-style.slt-style--opened').slideUp(300, function() {
                $(this).removeClass('slt-style--opened')
            }).siblings(".slt-styleoutter__arrow").removeClass("is-upside-down--top50")
        }
    })
}

function style_input() {

    //帶有眼睛的密碼欄位
    if ($('.input-style-eye').length > 0) {
        $('.input-style-eye .input-style-eye__iconeyeslash').click(function() {
            $(this).hide()
            $(this).siblings('.input-style-eye__iconeye').show()
            $(this).siblings('.input-style-eye__input').attr('type', 'text')
        })
        $('.input-style-eye .input-style-eye__iconeye').click(function() {
            $(this).hide()
            $(this).siblings('.input-style-eye__iconeyeslash').show()
            $(this).siblings('.input-style-eye__input').attr('type', 'password')
        })
    }

}

function tabboxControl(animate_switch) {

    //animate_switch 是否開啟.tabbox__child的伸展動畫

    $('.tabbox').each(function() {
        var whichPage = $(this).data('current')
        var that = $(this)
        var mother = []
        var targetChildHeight = 0
        var time_heightTransition = 800 //.tabbox__children高度動畫的毫秒數
        var time_transitionToFade = -300 //.tabbox__children高度動畫完成後幾毫秒換.tabbox__child出現
            //.tabbox__child的動畫秒數從sass改

        //Inital
        that.children('.tabbox__mothers').children('.tabbox__mother').each(function() {
            mother.push($(this))
        })

        if (whichPage != undefined) {
            that.children('.tabbox__mothers').children('.tabbox__mother').eq(whichPage - 1).addClass('tabbox__mother--active')
        } else {
            that.children('.tabbox__mothers').children('.tabbox__mother').eq(0).addClass('tabbox__mother--active')
        }

        if (whichPage != undefined) {
            that.children('.tabbox__children').children('.tabbox__child').eq(whichPage - 1).addClass('tabbox__child--active')
            if (animate_switch == true) {
                targetChildHeight = that.children('.tabbox__children').children('.tabbox__child').eq(whichPage - 1).outerHeight()
            }
        } else {
            that.children('.tabbox__children').children('.tabbox__child').eq(0).addClass('tabbox__child--active')
            if (animate_switch == true) {
                targetChildHeight = that.children('.tabbox__children').children('.tabbox__child').eq(0).outerHeight()
            }
        }

        //若有開啟動畫，則設定漸變秒數和延遲秒數
        if (animate_switch == true) {
            that.children('.tabbox__children').css({ 'transition': time_heightTransition / 1000 + 's height' })
            that.children('.tabbox__children').children('.tabbox__child').css({ 'animation-delay': (time_heightTransition + time_transitionToFade) / 1000 + 's' })
        }

        mother.forEach(function(v, i) {
            //將mother裡的元素複製到各自的child裡，並將原元素刪除，只留純文字
            var mother_tag = v.children().eq(0).prop('tagName')
            var mother_title = v.text().trim()
            v.html(mother_title)
            that.children('.tabbox__children').children('.tabbox__child').eq(i).prepend(`
                <${mother_tag} class="is-existhidden">${mother_title}</${mother_tag}>
            `)

            //當mother被點擊時
            v.click(function() {
                v.siblings('.tabbox__mother').removeClass('tabbox__mother--active')
                v.addClass('tabbox__mother--active')
                if (animate_switch == true) {
                    //先給一次高度，之後再給要顯示的child的高度時，才會有漸變動畫
                    that.children('.tabbox__children').css({ 'height': targetChildHeight })
                }
                that.children('.tabbox__children').children('.tabbox__child').removeClass('tabbox__child--active')
                that.children('.tabbox__children').children('.tabbox__child').eq(i).addClass('tabbox__child--active')
                if (animate_switch == true) {
                    targetChildHeight = that.children('.tabbox__children').children('.tabbox__child').eq(i).outerHeight()
                    that.children('.tabbox__children').css('height', targetChildHeight)
                }
                // console.log(targetChildHeight)
            })
        })

        //當視窗大小改變時，更新targetChildHeight，並賦值給.tabbox__children
        $(window).resize(function() {
            targetChildHeight = that.children('.tabbox__children').children('.tabbox__child--active').outerHeight()
            that.children('.tabbox__children').css('height', targetChildHeight)
        })
    })

}


function inputTYPEcheck() {

    $('input[type="number"]').change(function() {
        var r = /^[1-9]\d*$/
            //  非0的正整數
        if (r.test($(this).val())) {} else {
            // console.log('不是數字')
            $(this).val(1)
        }
    })

    $('input[type="tel"]').change(function() {
        if (isNaN($(this).val())) {
            alert(
                "＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 輸入的電話號碼請為數字半形唷！：）"
            )
            $(this).val("")
        }
    })

    //E-MAIL格式檢查
    $('input[type="email"]').change(function() {
        $Emailchecking = IsEmail($(this).val())
        if ($Emailchecking == false) {
            alert("＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 請填寫正確的E-MAIL格式唷！：）")
            $(this).val("")
            $(this).blur() //離開焦點
        }
    })

    //電話格式檢查
    $("#telephone").change(function() {
        var regex = /^(\d{2,3}-?|\(\d{2,3}\))\d{3,4}-?\d{4}$/
        if (!regex.test($(this).val())) {
            alert(
                "＊＊＊＊＊貼心提醒＊＊＊＊＊\n\n 輸入的文字須符合電話格式(且為半形文字)！"
            )
            $(this).val("")
        }
    })

    //Email格式檢查
    function IsEmail(email) {
        var regex =
            /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
        if (!regex.test(email)) {
            return false
        } else {
            return true
        }
    }

    //密碼＆再次輸入密碼 需相同
    $("#repassword").change(function() {
        var pswd = $("#password").val()
        if (pswd == $(this).val()) {} else {
            alert("密碼須相同")
            $(this).val("")
        }
    })

    $("#password").change(function() {
        var pswdre = $("#repassword").val()
        if (pswdre == $(this).val()) {} else {
            if (pswdre.length == 0) {} else {
                alert("密碼須相同")
                $("#repassword").val("")
            }
        }
    })

    // Class套用
    $('input[type="text"]').change(function() {
        if ($(this).val() == "") {
            $(this).removeClass("input-style-A--success")
        } else {
            $(this).addClass("input-style-A--success")
        }
    })

    $("textarea").change(function() {
        if ($(this).val() == "") {
            $(this).removeClass("input-style-A--success")
        } else {
            $(this).addClass("input-style-A--success")
        }
    })

    $(".input-style-C").focus(function() {
        $(this)
            .parent(".input-style-C-outter")
            .addClass("input-style-C-outter--success")
    })

    $(".input-style-C").blur(function() {
        if ($(this).val() == "") {
            $(this)
                .parent(".input-style-C-outter")
                .removeClass("input-style-C-outter--success")
        } else {
            $(this)
                .parent(".input-style-C-outter")
                .addClass("input-style-C-outter--success")
        }
    })
}


// item appear way
function waterfallshow(cp) {
    //cp = $currentpage
    //Give .wow.fadeIn class in DOM's target

    if (cp == 'PRODUCTS') {
        var j = 1;
        $('.productbox').each(function() {
            // $(this).attr('id', 'pc' + i);
            j++;
            $(this).attr('data-wow-delay', (j / 10) + 's');
            $(this).attr('data-wow-offset', -20000);
        })
    }

}

function BLOCKAnimation(nowpage) {
    var scrollTrigger = 400 // px
    var wh = $(window).height()

    if (nowpage == "INDEX") {
        Animation_aboutarea_done = false
        Animation_newsarea_done = false

        Detectblock = function() {
            //首頁Aboutarea 進場動畫
            Animation_aboutarea = function() {
                $(".aboutarea__meatball").addClass("fadeIn")
                $(".aboutarea__meatball").addClass("animated")

                setTimeout(function() {
                    $(".aboutarea__sauce").addClass("fadeIn")
                    $(".aboutarea__sauce").addClass("animated")
                }, 500)

                setTimeout(function() {
                    $(".newsarea__seafood").addClass("fadeIn")
                    $(".newsarea__seafood").addClass("animated")
                }, 800)

                setTimeout(function() {
                    $(".block-aboutarea .heading-index").addClass("ghostInDown")
                }, 1100)

                setTimeout(function() {
                    $(".aboutarea__content").addClass("ghostInUp")
                }, 1300)

                setTimeout(function() {
                    $(
                        ".block-aboutarea .heading-index .heading-index__cloud img"
                    ).addClass("ghostInRightUp")
                }, 1500)

                Animation_aboutarea_done = true
            }

            //首頁Newsarea 進場動畫
            Animation_newsarea = function() {
                setTimeout(function() {
                    $(".newsarea__title").addClass("fadeInLeft")
                    $(".newsarea__title").addClass("animated")
                }, 500)

                Animation_newsarea_done = true
            }
            if (Animation_aboutarea_done == true) {} else {
                var Distance_aboutarea =
                    wh - ($(".aboutarea").offset().top - $(window).scrollTop())
                if (Distance_aboutarea <= scrollTrigger) {} else if (Distance_aboutarea > wh) {} else {
                    Animation_aboutarea()
                }
            }

            if (Animation_newsarea_done == true) {} else {
                var Distance_newsarea =
                    wh - ($(".newsarea").offset().top - $(window).scrollTop())
                if (Distance_newsarea <= scrollTrigger) {} else if (Distance_newsarea > wh) {} else {
                    Animation_newsarea()
                }
            }
        }

        Detectblock()
        $(window).on("scroll", function() {
            Detectblock()
        })
    }
}

//目標物$(''), 目標物離window距離多少觸發(上 右 下 左), config設定值, 進入作用範圍觸發的函式(that變數為目標物),離開作用範圍觸發的函式(若視窗移向目標物的上方)
// ScrollReachRun('.section1', '-200px 0px -200px 0px', {
//         repeat: true,
//         mirror: false,
//         individual: true,
//     },
//     (that) => {
//         // console.log('進入作用範圍')
//     },
//     (that) => {
//         // console.log('離開作用範圍')
//     })

function ScrollReachRun(target_class, TriggerDistance, config, func_in, func_out) {

    var isRepeat = config.repeat;
    var isMirror = config.mirror;
    var isIndividual = config.individual;

    // 🌟 1. 建立一個 WeakMap，用來儲存每個獨立元素的專屬紀錄
    const scrollRegistry = new WeakMap();

    const options = {
        root: null,
        rootMargin: TriggerDistance,
        threshold: 0
    };

    const callback = (entries, observer) => {
        entries.forEach(entry => {
            var currentY = entry.boundingClientRect.top;
            var currentRatio = entry.intersectionRatio;
            var isIntersecting = entry.isIntersecting;

            var isFirstSetup = !scrollRegistry.has(entry.target); // 判斷是不是第一次被觀察

            // 🌟 2. 從 WeakMap 抓取「這張卡片」專屬的上一次 Y 座標
            // 如果是第一次進來（還沒有紀錄），就先暫時設定為目前的 currentY
            var previousY = isFirstSetup ? currentY : scrollRegistry.get(entry.target).y;

            // 判斷捲動方向：如果目前的 Y 小於之前的 Y，代表頁面正在「向下捲動」
            var isScrollingDown = currentY < previousY;

            // console.log('--- 觸發元素:', entry.target, '---');
            // console.log('currentY:', currentY);
            // console.log('previousY:', previousY);
            // console.log('isScrollingDown:', isScrollingDown);

            if (isIntersecting) {
                if (isMirror) {
                    if (isIndividual) {
                        func_in($(entry.target));
                        // console.log('目標元素進入範圍了！');
                    } else {
                        func_in($(target_class));
                        // console.log('所有目標元素進入範圍了！');
                    }

                    if (!isRepeat) {
                        observer.unobserve(entry.target);
                    }
                } else {
                    if (isScrollingDown || isFirstSetup) {
                        if (isIndividual) {
                            func_in($(entry.target));
                            // console.log('目標元素進入範圍了！');
                        } else {
                            func_in($(target_class));
                            // console.log('所有目標元素進入範圍了！');
                        }

                        if (!isRepeat) {
                            observer.unobserve(entry.target);
                        }
                    }
                }
            } else {
                if (!isFirstSetup) {
                    if (isScrollingDown) {
                        if (isMirror) {
                            if (isIndividual) {
                                func_out($(entry.target));
                                // console.log('目標元素離開範圍了。');
                            } else {
                                func_out($(target_class));
                                // console.log('所有目標元素離開範圍了。');
                            }
                        }
                    } else {
                        if (isRepeat) {
                            if (isIndividual) {
                                func_out($(entry.target));
                                // console.log('目標元素離開範圍了。');
                            } else {
                                func_out($(target_class));
                                // console.log('所有目標元素離開範圍了。');
                            }
                        }
                    }
                }
            }

            // 🌟 3. 更新「這張卡片」的專屬紀錄，供下次捲動時比對
            scrollRegistry.set(entry.target, { y: currentY, ratio: currentRatio });
        });
    };

    // console.log(target_class);
    const observer = new IntersectionObserver(callback, options);
    const targets = document.querySelectorAll(target_class);

    targets.forEach(target => {
        // 這裡呼叫 observe 時，IntersectionObserver 會馬上觸發第一次 callback
        // 剛好幫每個卡片寫入最初始的 currentY 到 WeakMap 中
        observer.observe(target);
    });

}

// 設定 cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
}

// 取得 cookie
function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(";")[0]);
    }
    return "";
}

// 刪除 cookie
function deleteCookie(name) {
    document.cookie = name + "=; max-age=0; path=/;";
    console.log('cookie deleted :', name)
}

function policyblock() {

    var websitename = $('head title').text()

    //中文版隱私權政策
    $(".block-policy--cht").html(
        `
            <article class='policy_page'>
                <div class='policy_pageBlank'>
                    <div class='policy_wp'>
                        <div class='policy_content'>
                            <div class='policy_title1'>隱私權政策 Private Policy</div> 非常歡迎您光臨「${websitename}」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容： <br><br>
                            <div class='policy_title2'>一、隱私權保護政策的適用範圍</div> 隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。 <br> <br>
                            <div class='policy_title2'>二、個人資料的蒐集、處理及利用方式</div> 當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。 <br> 本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。 <br> 於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。
                            <br> 為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。 <br> <br>
                            <div class='policy_title2'>三、資料之保護</div> 本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。 <br> 如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。 <br> <br>
                            <div class='policy_title2'>四、網站對外的相關連結</div> 本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。 <br> <br>
                            <div class='policy_title2'>五、與第三人共用個人資料之政策</div> 本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。 <br> <br> 前項但書之情形包括不限於： <br> <br> 經由您書面同意。 <br> 法律明文規定。 <br> 為免除您生命、身體、自由或財產上之危險。 <br> 與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。
                            <br> 當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。 <br> 有利於您的權益。 <br> 本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。 <br> <br>
                            <div class='policy_title2'>六、Cookie之使用</div> 為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導致網站某些功能無法正常執行 。<br> <br>
                            <div class='policy_title2'>七、隱私權保護政策之修正</div> 本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。 <br>
                            <div class='policy_page_bottom'> <input type='button' value='關閉' name='Close' class='policy_btn close_WindowBtn'> </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class='policy_LinkBlank'>
                <div class='policy_LinkWindow'>
                    <div class='policy_wp'>
                        <div class="policy_desc">
                            <p>為達到最佳的瀏覽體驗，本網站使用cookies，若您繼續瀏覽本網站代表您同意我們的隱私權政策。</p>
                            <div class="policy_btn-outer">
                                <a href='javascript:' class='policy_link window_OpenLink'>隱私權聲明</a> 
                                <input type='button' value='好' name='Agree' class='policy_btn agree_btn'>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        `
    )

    //英文版隱私權政策
    $(".block-policy--en").html(
        `
            <article class='policy_page'>
                <div class='policy_pageBlank'>
                    <div class='policy_wp'>
                        <div class='policy_content'>
                            <div class='policy_title1'>Privacy Statement</div>
                            <div>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. </div>
                            <div>We may use your data in improving the user experience. By using the website and the service, you agree the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy,
                                terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Information Collection and Use</div>
                                <div>We collect different types of information for various purposes to provide and improve our Website to you.</div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Types of Data Collected</div> <br/>
                                <div style='font-size:1.1em; font-weight:500;'>(a) Personal Data</div>
                                <div>When you fill the ‘Contact Us’ form in our website, you provide us with certain personally identifiable information that can be used to contact or identify you ('Personal Data'). Personal Data be stored only if you
                                    choose to submit it to us. </div>
                                <div>Personally identifiable information may include, but is not limited to: </div>
                                <ul>
                                    <li>Email address</li>
                                    <li>First name and last name</li>
                                    <li>Phone number</li>
                                    <li>Address, state, province, ZIP/postal code, city and country</li>
                                </ul>
                                <hr>
                                <div style='font-size:1.1em; font-weight:500;'>(b) Usage Data</div>
                                <div>We may also collect information on how the Website is accessed and used ('Usage Data'). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser
                                    version, the pages of our Website that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data. </div>
                                <hr>
                                <div style='font-size:1.1em; font-weight:500;'>(c) Tracking Cookies Data</div>
                                <div>Cookies are small files stored on your desktop, laptop or mobile device by websites visited by you. They enable us to e.g. recognize whether there has been a previous connection between your device and our websites,
                                    take into account your preferred language or other settings, offer you certain functionalities or recognize your interests on the basis of previous use. Cookies can also contain personal information.</div>
                            </div>
                            <div class='policy_part'>
                                <div>You can also visit our websites without consenting to the use of cookies by such use. In other words, you can reject the use of cookies and delete them at any time by making the appropriate settings to your device.
                                </div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Examples of Cookies we use:</div>
                                <ul>
                                    <li><strong>Session Cookies: </strong>We use Session Cookies to operate our Service.</li>
                                    <li><strong>Preference Cookies: </strong>We use Preference Cookies to remember your preferences and various settings.</li>
                                    <li><strong>Security Cookies: </strong>We use Security Cookies for security purposes.</li>
                                </ul>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Use of Data</div>
                                <div>We uses the collected data for various purposes:</div>
                                <ul>
                                    <li>To provide and maintain the Website.</li>
                                    <li>To notify you about changes to our Website.</li>
                                    <li>To allow you to participate in interactive features of our Website when you choose to do so.</li>
                                    <li>To provide customer care and support.</li>
                                    <li>To provide analysis or valuable information so that we can improve our Website to you.</li>
                                    <li>To monitor the usage of the Website.</li>
                                    <li>To detect, prevent and address technical issues.</li>
                                </ul>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Transfer of Data</div>
                                <div>Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may
                                    differ than those from your jurisdiction. </div>
                                <div>If you are located outside Taiwan and choose to provide information to us, please note that we transfer the data, including Personal Data, to Taiwan and process it there.</div>
                                <div>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer. </div>
                                <div>We will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country
                                    unless there are adequate controls in place including the security of your data and other personal information.</div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Disclosure of Data</div>
                                <div>We may disclose your Personal Data in the good faith belief that such action is necessary to:</div>
                                <ul>
                                    <li>To comply with a legal obligation.</li>
                                    <li>To protect and defend the rights or property of We.</li>
                                    <li>To prevent or investigate possible wrongdoing in connection with the Website.</li>
                                    <li>To protect the personal safety of users of the Website or the public.</li>
                                    <li>To protect against legal liability.</li>
                                </ul>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Security of Data</div>
                                <div>The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect
                                    your Personal Data, we cannot guarantee its absolute security. </div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Third Party Service Providers</div>
                                <div>We may employ third party companies and individuals to facilitate our Service ('Service Providers'), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Website
                                    is used. </div>
                                <div>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. </div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Links to Other Sites</div>
                                <div>Our Service may contain links to other sites, including sites provided by social media service providers, that are not operated by us. If you click on a third party link, you will be directed to that third party's site.
                                    We strongly advise you to review the Privacy Policy of every site you visit.</div>
                                <div>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Right to Information, Correction, Deletion and Blocking of Data</div>
                                <div>You have the right to be informed at any time about your personal data, free of charge, if you request that any incorrect information to be corrected, and any personal data should be deleted and blocked. </div>
                            </div>
                            <div class='policy_part'>
                                <div class='policy_title2'>Changes to This Privacy Policy</div>
                                <div>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. </div>
                                <div>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</div>
                            </div>
                            <div><strong>Contact Us</strong><br/>If you have any questions about this Privacy Policy, please contact us. </div>
                            <div>This Privacy Policy is updated on <strong>May. 23. 2025</strong>.</div>
                            <div class='policy_page_bottom'> <input type='button' value='Close' name='Close' class='policy_btn close_WindowBtn'> </div>
                        </div>
                    </div>
                </div>
            </article>
            <article class='policy_LinkBlank'>
                <div class='policy_LinkWindow'>
                    <div class='policy_wp'>
                        <div class="policy_desc">We use cookies to improve our website, to make it easier for users to operate and to continuously upgrade. By continuing to use this page, you agree to the use of cookies.
                            <div class='policy_btn-outer'>
                                <a href='javascript:' class='policy_link window_OpenLink'>Learn more</a>
                                <input type='button' value='Agree' name='Agree' class='policy_btn agree_btn'>
                            </div>
                        </div>
                    </div>
            </article>
        `
    )

    //使用cookie判斷 近期是否有按過同意
    if (getCookie('privacy') === 'true') {} else {
        $("#block-policy").show()
        $(".policy_btn.agree_btn").click(function() {
            setCookie('privacy', 'true', 7)
        })
    }

    //隱私權視窗
    $(".agree_btn").click(function() {
        $(".policy_LinkBlank").css("display", "none")
    })
    $(".window_OpenLink").click(function() {
        $(".policy_LinkBlank").css("display", "none")
        $(".policy_pageBlank").css("display", "block")
        $("body").addClass("blackBg")
            // $("body").find('.policy_content').niceScroll({ cursorcolor: "#00A4EA", background: "#EFEFEF", cursorborder: "0.5px solid #00A4EA" });
    })
    $(".close_WindowBtn").click(function() {
            $(".policy_pageBlank").css("display", "none")
            $("body").removeClass("blackBg")
        })
        //判斷手機版的方向(直式與橫式)
        // window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function() {
        //     if (window.orientation === 90 || window.orientation === -90) {
        //         $('.policy_content').css('max-height', '200px');
        //         $('.policy_pageBlank').css('height', '280px');
        //         //目前螢幕為橫向！
        //     }
        //     if (window.orientation === 180 || window.orientation === 0) {
        //         $('.policy_content').css('max-height', '350px');
        //         $('.policy_pageBlank').css('height', '430px');
        //         //目前螢幕為縱向！
        //     }
        // }, false);
}

// function niceScroll_initial() {
//     $('html').niceScroll({
//         cursorcolor: "#054786",
//         scrollspeed: 40, // 滾動時間
//         mousescrollstep: 45, // 滾動速度
//         cursorwidth: "8px"
//     });
// }

function recaptchaAlert() {
    alert("請勾選我不是機器人驗證，謝謝！")
}

//國家列表下拉選單
function SelectCountryLoad() {
    var countrylist = `
    <div data-value='AD' class="slt-style__option slt-style-C__option" data-mother-id="0">安道爾 Andorra</div>
    <div data-value='AE' class="slt-style__option slt-style-C__option" data-mother-id="1">阿拉伯聯合大公國 United Arab Emirates</div>
    <div data-value='AF' class="slt-style__option slt-style-C__option" data-mother-id="2">阿富汗 Afghanistan</div>
    <div data-value='AG' class="slt-style__option slt-style-C__option" data-mother-id="3">安地卡巴布達 Antigua and Barbuda</div>
    <div data-value='AI' class="slt-style__option slt-style-C__option" data-mother-id="4">安圭拉 Anguilla</div>
    <div data-value='AL' class="slt-style__option slt-style-C__option" data-mother-id="5">阿爾巴尼亞 Albania</div>
    <div data-value='AM' class="slt-style__option slt-style-C__option" data-mother-id="6">亞美尼亞 Armenia</div>
    <div data-value='AN' class="slt-style__option slt-style-C__option" data-mother-id="7">荷屬安地列斯 Netherlands Antilles</div>
    <div data-value='AO' class="slt-style__option slt-style-C__option" data-mother-id="8">安哥拉 Angola</div>
    <div data-value='AQ' class="slt-style__option slt-style-C__option" data-mother-id="9">南極洲 Antarctica</div>
    <div data-value='AR' class="slt-style__option slt-style-C__option" data-mother-id="10">阿根廷 Argentina</div>
    <div data-value='AS' class="slt-style__option slt-style-C__option" data-mother-id="11">美屬薩摩亞 American Samoa</div>
    <div data-value='AT' class="slt-style__option slt-style-C__option" data-mother-id="12">奧地利 Austria</div>
    <div data-value='AU' class="slt-style__option slt-style-C__option" data-mother-id="13">澳大利亞 Australia</div>
    <div data-value='AW' class="slt-style__option slt-style-C__option" data-mother-id="14">阿魯巴 Aruba</div>
    <div data-value='AX' class="slt-style__option slt-style-C__option" data-mother-id="15">奧蘭群島 Åland Islands</div>
    <div data-value='AZ' class="slt-style__option slt-style-C__option" data-mother-id="16">亞塞拜然 Azerbaijan</div>
    <div data-value='BA' class="slt-style__option slt-style-C__option" data-mother-id="17">波士尼亞赫塞哥維納 Bosnia and Herzegovina</div>
    <div data-value='BB' class="slt-style__option slt-style-C__option" data-mother-id="18">巴貝多 Barbados</div>
    <div data-value='BD' class="slt-style__option slt-style-C__option" data-mother-id="19">孟加拉 Bangladesh</div>
    <div data-value='BE' class="slt-style__option slt-style-C__option" data-mother-id="20">比利時 Belgium</div>
    <div data-value='BF' class="slt-style__option slt-style-C__option" data-mother-id="21">布吉納法索 Burkina Faso</div>
    <div data-value='BG' class="slt-style__option slt-style-C__option" data-mother-id="22">保加利亞 Bulgaria</div>
    <div data-value='BH' class="slt-style__option slt-style-C__option" data-mother-id="23">巴林 Bahrain</div>
    <div data-value='BI' class="slt-style__option slt-style-C__option" data-mother-id="24">蒲隆地 Burundi</div>
    <div data-value='BJ' class="slt-style__option slt-style-C__option" data-mother-id="25">貝南 Benin</div>
    <div data-value='BM' class="slt-style__option slt-style-C__option" data-mother-id="26">百慕達 Bermuda</div>
    <div data-value='BN' class="slt-style__option slt-style-C__option" data-mother-id="27">汶萊 Brunei Darussalam</div>
    <div data-value='BO' class="slt-style__option slt-style-C__option" data-mother-id="28">玻利維亞 Bolivia</div>
    <div data-value='BR' class="slt-style__option slt-style-C__option" data-mother-id="29">巴西 Brazil</div>
    <div data-value='BS' class="slt-style__option slt-style-C__option" data-mother-id="30">巴哈馬 Bahamas</div>
    <div data-value='BT' class="slt-style__option slt-style-C__option" data-mother-id="31">不丹 Bhutan</div>
    <div data-value='BV' class="slt-style__option slt-style-C__option" data-mother-id="32">波維特島 Bouvet Island</div>
    <div data-value='BW' class="slt-style__option slt-style-C__option" data-mother-id="33">波札那 Botswana</div>
    <div data-value='BY' class="slt-style__option slt-style-C__option" data-mother-id="34">白俄羅斯 Belarus</div>
    <div data-value='BZ' class="slt-style__option slt-style-C__option" data-mother-id="35">貝里斯 Belize</div>
    <div data-value='CA' class="slt-style__option slt-style-C__option" data-mother-id="36">加拿大 Canada</div>
    <div data-value='CC' class="slt-style__option slt-style-C__option" data-mother-id="37">可可斯群島 Cocos (Keeling) Islands</div>
    <div data-value='CD' class="slt-style__option slt-style-C__option" data-mother-id="38">剛果民主共和國 The Democratic Republic of The Congo</div>
    <div data-value='CF' class="slt-style__option slt-style-C__option" data-mother-id="39">中非共和國 Central African Republic</div>
    <div data-value='CG' class="slt-style__option slt-style-C__option" data-mother-id="40">剛果 Congo</div>
    <div data-value='CH' class="slt-style__option slt-style-C__option" data-mother-id="41">瑞士 Switzerland</div>
    <div data-value='CI' class="slt-style__option slt-style-C__option" data-mother-id="42">象牙海岸 Côte D'Ivoire</div>
    <div data-value='CK' class="slt-style__option slt-style-C__option" data-mother-id="43">庫克群島 Cook Islands</div>
    <div data-value='CL' class="slt-style__option slt-style-C__option" data-mother-id="44">智利 Chile</div>
    <div data-value='CM' class="slt-style__option slt-style-C__option" data-mother-id="45">喀麥隆 Cameroon</div>
    <div data-value='CN' class="slt-style__option slt-style-C__option" data-mother-id="46">中國 China</div>
    <div data-value='CO' class="slt-style__option slt-style-C__option" data-mother-id="47">哥倫比亞 Colombia</div>
    <div data-value='CR' class="slt-style__option slt-style-C__option" data-mother-id="48">哥斯大黎加 Costa Rica</div>
    <div data-value='CU' class="slt-style__option slt-style-C__option" data-mother-id="49">古巴 Cuba</div>
    <div data-value='CV' class="slt-style__option slt-style-C__option" data-mother-id="50">維德角 Cape Verde</div>
    <div data-value='CX' class="slt-style__option slt-style-C__option" data-mother-id="51">聖誕島 Christmas Island</div>
    <div data-value='CY' class="slt-style__option slt-style-C__option" data-mother-id="52">賽普勒斯 Cyprus</div>
    <div data-value='CZ' class="slt-style__option slt-style-C__option" data-mother-id="53">捷克 Czech Republic</div>
    <div data-value='DE' class="slt-style__option slt-style-C__option" data-mother-id="54">德國 Germany</div>
    <div data-value='DJ' class="slt-style__option slt-style-C__option" data-mother-id="55">吉布地 Djibouti</div>
    <div data-value='DK' class="slt-style__option slt-style-C__option" data-mother-id="56">丹麥 Denmark</div>
    <div data-value='DM' class="slt-style__option slt-style-C__option" data-mother-id="57">多米尼克 Dominica</div>
    <div data-value='DO' class="slt-style__option slt-style-C__option" data-mother-id="58">多明尼加 Dominican Republic</div>
    <div data-value='DZ' class="slt-style__option slt-style-C__option" data-mother-id="59">阿爾及利亞 Algeria</div>
    <div data-value='EC' class="slt-style__option slt-style-C__option" data-mother-id="60">厄瓜多 Ecuador</div>
    <div data-value='EE' class="slt-style__option slt-style-C__option" data-mother-id="61">愛沙尼亞 Estonia</div>
    <div data-value='EG' class="slt-style__option slt-style-C__option" data-mother-id="62">埃及 Egypt</div>
    <div data-value='EH' class="slt-style__option slt-style-C__option" data-mother-id="63">西撒哈拉 Western Sahara</div>
    <div data-value='ER' class="slt-style__option slt-style-C__option" data-mother-id="64">厄利垂亞 Eritrea</div>
    <div data-value='ES' class="slt-style__option slt-style-C__option" data-mother-id="65">西班牙 Spain</div>
    <div data-value='ET' class="slt-style__option slt-style-C__option" data-mother-id="66">衣索比亞 Ethiopia</div>
    <div data-value='FI' class="slt-style__option slt-style-C__option" data-mother-id="67">芬蘭 Finland</div>
    <div data-value='FJ' class="slt-style__option slt-style-C__option" data-mother-id="68">斐濟 Fiji</div>
    <div data-value='FK' class="slt-style__option slt-style-C__option" data-mother-id="69">福克蘭群島 Falkland Islands (Malvinas)</div>
    <div data-value='FM' class="slt-style__option slt-style-C__option" data-mother-id="70">密克羅尼西亞聯邦 Federated States of Micronesia</div>
    <div data-value='FO' class="slt-style__option slt-style-C__option" data-mother-id="71">法羅群島 Faroe Islands</div>
    <div data-value='FR' class="slt-style__option slt-style-C__option" data-mother-id="72">法國 France</div>
    <div data-value='GA' class="slt-style__option slt-style-C__option" data-mother-id="73">加彭 Gabon</div>
    <div data-value='GB' class="slt-style__option slt-style-C__option" data-mother-id="74">英國 United Kingdom</div>
    <div data-value='GD' class="slt-style__option slt-style-C__option" data-mother-id="75">格瑞那達 Grenada</div>
    <div data-value='GE' class="slt-style__option slt-style-C__option" data-mother-id="76">喬治亞 Georgia</div>
    <div data-value='GF' class="slt-style__option slt-style-C__option" data-mother-id="77">法屬圭亞那 French Guiana</div>
    <div data-value='GG' class="slt-style__option slt-style-C__option" data-mother-id="78">根息 Guernsey</div>
    <div data-value='GH' class="slt-style__option slt-style-C__option" data-mother-id="79">迦納 Ghana</div>
    <div data-value='GI' class="slt-style__option slt-style-C__option" data-mother-id="80">直布羅陀 Gibraltar</div>
    <div data-value='GL' class="slt-style__option slt-style-C__option" data-mother-id="81">格陵蘭 Greenland</div>
    <div data-value='GM' class="slt-style__option slt-style-C__option" data-mother-id="82">甘比亞 Gambia</div>
    <div data-value='GN' class="slt-style__option slt-style-C__option" data-mother-id="83">幾內亞 Guinea</div>
    <div data-value='GP' class="slt-style__option slt-style-C__option" data-mother-id="84">哥德洛普 Guadeloupe</div>
    <div data-value='GQ' class="slt-style__option slt-style-C__option" data-mother-id="85">赤道幾內亞 Equatorial Guinea</div>
    <div data-value='GR' class="slt-style__option slt-style-C__option" data-mother-id="86">希臘 Greece</div>
    <div data-value='GS' class="slt-style__option slt-style-C__option" data-mother-id="87">南喬治亞南桑威奇群島 South Georgia and The South Sandwich Islands</div>
    <div data-value='GT' class="slt-style__option slt-style-C__option" data-mother-id="88">瓜地馬拉 Guatemala</div>
    <div data-value='GU' class="slt-style__option slt-style-C__option" data-mother-id="89">關島 Guam</div>
    <div data-value='GW' class="slt-style__option slt-style-C__option" data-mother-id="90">幾內亞比索 Guinea-Bissau</div>
    <div data-value='GY' class="slt-style__option slt-style-C__option" data-mother-id="91">蓋亞那 Guyana</div>
    <div data-value='HK' class="slt-style__option slt-style-C__option" data-mother-id="92">香港 Hong Kong</div>
    <div data-value='HM' class="slt-style__option slt-style-C__option" data-mother-id="93">赫德麥當勞群島 Heard Island and Mcdonald Islands</div>
    <div data-value='HN' class="slt-style__option slt-style-C__option" data-mother-id="94">宏都拉斯 Honduras</div>
    <div data-value='HR' class="slt-style__option slt-style-C__option" data-mother-id="95">克羅埃西亞 Croatia</div>
    <div data-value='HT' class="slt-style__option slt-style-C__option" data-mother-id="96">海地 Haiti</div>
    <div data-value='HU' class="slt-style__option slt-style-C__option" data-mother-id="97">匈牙利 Hungary</div>
    <div data-value='ID' class="slt-style__option slt-style-C__option" data-mother-id="98">印尼 Indonesia</div>
    <div data-value='IE' class="slt-style__option slt-style-C__option" data-mother-id="99">愛爾蘭 Ireland</div>
    <div data-value='IL' class="slt-style__option slt-style-C__option" data-mother-id="100">以色列 Israel</div>
    <div data-value='IM' class="slt-style__option slt-style-C__option" data-mother-id="101">曼島 Isle of Man</div>
    <div data-value='IN' class="slt-style__option slt-style-C__option" data-mother-id="102">印度 India</div>
    <div data-value='IO' class="slt-style__option slt-style-C__option" data-mother-id="103">英屬印度洋地區 British Indian Ocean Territory</div>
    <div data-value='IQ' class="slt-style__option slt-style-C__option" data-mother-id="104">伊拉克 Iraq</div>
    <div data-value='IR' class="slt-style__option slt-style-C__option" data-mother-id="105">伊朗 Islamic Republic of Iran</div>
    <div data-value='IS' class="slt-style__option slt-style-C__option" data-mother-id="106">冰島 Iceland</div>
    <div data-value='IT' class="slt-style__option slt-style-C__option" data-mother-id="107">義大利 Italy</div>
    <div data-value='JE' class="slt-style__option slt-style-C__option" data-mother-id="108">澤西 Jersey</div>
    <div data-value='JM' class="slt-style__option slt-style-C__option" data-mother-id="109">牙買加 Jamaica</div>
    <div data-value='JO' class="slt-style__option slt-style-C__option" data-mother-id="110">約旦 Jordan</div>
    <div data-value='JP' class="slt-style__option slt-style-C__option" data-mother-id="111">日本 Japan</div>
    <div data-value='KE' class="slt-style__option slt-style-C__option" data-mother-id="112">肯亞 Kenya</div>
    <div data-value='KG' class="slt-style__option slt-style-C__option" data-mother-id="113">吉爾吉斯 Kyrgyzstan</div>
    <div data-value='KH' class="slt-style__option slt-style-C__option" data-mother-id="114">柬埔寨 Cambodia</div>
    <div data-value='KI' class="slt-style__option slt-style-C__option" data-mother-id="115">吉里巴斯 Kiribati</div>
    <div data-value='KM' class="slt-style__option slt-style-C__option" data-mother-id="116">葛摩 Comoros</div>
    <div data-value='KN' class="slt-style__option slt-style-C__option" data-mother-id="117">聖克里斯多福 Saint Kitts and Nevis</div>
    <div data-value='KP' class="slt-style__option slt-style-C__option" data-mother-id="118">北韓 Democratic People's Republic of Korea</div>
    <div data-value='KR' class="slt-style__option slt-style-C__option" data-mother-id="119">南韓 Republic of Korea</div>
    <div data-value='KW' class="slt-style__option slt-style-C__option" data-mother-id="120">科威特 Kuwait</div>
    <div data-value='KY' class="slt-style__option slt-style-C__option" data-mother-id="121">開曼群島 Cayman Islands</div>
    <div data-value='KZ' class="slt-style__option slt-style-C__option" data-mother-id="122">哈薩克 Kazakhstan</div>
    <div data-value='LA' class="slt-style__option slt-style-C__option" data-mother-id="123">寮國 Lao People's Democratic Republic</div>
    <div data-value='LB' class="slt-style__option slt-style-C__option" data-mother-id="124">黎巴嫩 Lebanon</div>
    <div data-value='LC' class="slt-style__option slt-style-C__option" data-mother-id="125">聖露西亞 Saint Lucia</div>
    <div data-value='LI' class="slt-style__option slt-style-C__option" data-mother-id="126">列支敦斯登 Liechtenstein</div>
    <div data-value='LK' class="slt-style__option slt-style-C__option" data-mother-id="127">斯里蘭卡 Sri Lanka</div>
    <div data-value='LR' class="slt-style__option slt-style-C__option" data-mother-id="128">賴比瑞亞 Liberia</div>
    <div data-value='LS' class="slt-style__option slt-style-C__option" data-mother-id="129">賴索托 Lesotho</div>
    <div data-value='LT' class="slt-style__option slt-style-C__option" data-mother-id="130">立陶宛 Lithuania</div>
    <div data-value='LU' class="slt-style__option slt-style-C__option" data-mother-id="131">盧森堡 Luxembourg</div>
    <div data-value='LV' class="slt-style__option slt-style-C__option" data-mother-id="132">拉脫維亞 Latvia</div>
    <div data-value='LY' class="slt-style__option slt-style-C__option" data-mother-id="133">利比亞 Libyan Arab Jamahiriya</div>
    <div data-value='MA' class="slt-style__option slt-style-C__option" data-mother-id="134">摩洛哥 Morocco</div>
    <div data-value='MC' class="slt-style__option slt-style-C__option" data-mother-id="135">摩納哥 Monaco</div>
    <div data-value='MD' class="slt-style__option slt-style-C__option" data-mother-id="136">摩爾多瓦 Republic of Moldova</div>
    <div data-value='ME' class="slt-style__option slt-style-C__option" data-mother-id="137">蒙特內哥羅 Montenegro</div>
    <div data-value='MG' class="slt-style__option slt-style-C__option" data-mother-id="138">馬達加斯加 Madagascar</div>
    <div data-value='MH' class="slt-style__option slt-style-C__option" data-mother-id="139">馬紹爾群島 Marshall Islands</div>
    <div data-value='MK' class="slt-style__option slt-style-C__option" data-mother-id="140">馬其頓 Republic of Macedonia</div>
    <div data-value='ML' class="slt-style__option slt-style-C__option" data-mother-id="141">馬利 Mali</div>
    <div data-value='MM' class="slt-style__option slt-style-C__option" data-mother-id="142">緬甸 Myanmar</div>
    <div data-value='MN' class="slt-style__option slt-style-C__option" data-mother-id="143">蒙古 Mongolia</div>
    <div data-value='MO' class="slt-style__option slt-style-C__option" data-mother-id="144">澳門 Macao</div>
    <div data-value='MP' class="slt-style__option slt-style-C__option" data-mother-id="145">北馬里亞納群島 Northern Mariana Islands</div>
    <div data-value='MQ' class="slt-style__option slt-style-C__option" data-mother-id="146">馬丁尼克 Martinique</div>
    <div data-value='MR' class="slt-style__option slt-style-C__option" data-mother-id="147">茅利塔尼亞 Mauritania</div>
    <div data-value='MS' class="slt-style__option slt-style-C__option" data-mother-id="148">蒙特色拉 Montserrat</div>
    <div data-value='MT' class="slt-style__option slt-style-C__option" data-mother-id="149">馬爾他 Malta</div>
    <div data-value='MU' class="slt-style__option slt-style-C__option" data-mother-id="150">模里西斯 Mauritius</div>
    <div data-value='MV' class="slt-style__option slt-style-C__option" data-mother-id="151">馬爾地夫 Maldives</div>
    <div data-value='MW' class="slt-style__option slt-style-C__option" data-mother-id="152">馬拉威 Malawi</div>
    <div data-value='MX' class="slt-style__option slt-style-C__option" data-mother-id="153">墨西哥 Mexico</div>
    <div data-value='MY' class="slt-style__option slt-style-C__option" data-mother-id="154">馬來西亞 Malaysia</div>
    <div data-value='MZ' class="slt-style__option slt-style-C__option" data-mother-id="155">莫三比克 Mozambique</div>
    <div data-value='NA' class="slt-style__option slt-style-C__option" data-mother-id="156">納米比亞 Namibia</div>
    <div data-value='NC' class="slt-style__option slt-style-C__option" data-mother-id="157">新喀里多尼亞 New Caledonia</div>
    <div data-value='NE' class="slt-style__option slt-style-C__option" data-mother-id="158">尼日 Niger</div>
    <div data-value='NF' class="slt-style__option slt-style-C__option" data-mother-id="159">諾福克島 Norfolk Island</div>
    <div data-value='NG' class="slt-style__option slt-style-C__option" data-mother-id="160">奈及利亞 Nigeria</div>
    <div data-value='NI' class="slt-style__option slt-style-C__option" data-mother-id="161">尼加拉瓜 Nicaragua</div>
    <div data-value='NL' class="slt-style__option slt-style-C__option" data-mother-id="162">荷蘭 Netherlands</div>
    <div data-value='NO' class="slt-style__option slt-style-C__option" data-mother-id="163">挪威 Norway</div>
    <div data-value='NP' class="slt-style__option slt-style-C__option" data-mother-id="164">尼泊爾 Nepal</div>
    <div data-value='NR' class="slt-style__option slt-style-C__option" data-mother-id="165">諾魯 Nauru</div>
    <div data-value='NU' class="slt-style__option slt-style-C__option" data-mother-id="166">紐埃 Niue</div>
    <div data-value='NZ' class="slt-style__option slt-style-C__option" data-mother-id="167">紐西蘭 New Zealand</div>
    <div data-value='OM' class="slt-style__option slt-style-C__option" data-mother-id="168">阿曼 Oman</div>
    <div data-value='PA' class="slt-style__option slt-style-C__option" data-mother-id="169">巴拿馬 Panama</div>
    <div data-value='PE' class="slt-style__option slt-style-C__option" data-mother-id="170">秘魯 Peru</div>
    <div data-value='PF' class="slt-style__option slt-style-C__option" data-mother-id="171">法屬波里尼西亞 French Polynesia</div>
    <div data-value='PG' class="slt-style__option slt-style-C__option" data-mother-id="172">巴布亞紐幾內亞 Papua New Guinea</div>
    <div data-value='PH' class="slt-style__option slt-style-C__option" data-mother-id="173">菲律賓 Philippines</div>
    <div data-value='PK' class="slt-style__option slt-style-C__option" data-mother-id="174">巴基斯坦 Pakistan</div>
    <div data-value='PL' class="slt-style__option slt-style-C__option" data-mother-id="175">波蘭 Poland</div>
    <div data-value='PM' class="slt-style__option slt-style-C__option" data-mother-id="176">聖皮耶密克隆 Saint Pierre and Miquelon</div>
    <div data-value='PN' class="slt-style__option slt-style-C__option" data-mother-id="177">皮特康 Pitcairn</div>
    <div data-value='PR' class="slt-style__option slt-style-C__option" data-mother-id="178">波多黎各 Puerto Rico</div>
    <div data-value='PS' class="slt-style__option slt-style-C__option" data-mother-id="179">巴勒斯坦 Palestinian Territory, Occupied</div>
    <div data-value='PT' class="slt-style__option slt-style-C__option" data-mother-id="180">葡萄牙 Portugal</div>
    <div data-value='PW' class="slt-style__option slt-style-C__option" data-mother-id="181">帛琉 Palau</div>
    <div data-value='PY' class="slt-style__option slt-style-C__option" data-mother-id="182">巴拉圭 Paraguay</div>
    <div data-value='QA' class="slt-style__option slt-style-C__option" data-mother-id="183">卡達 Qatar</div>
    <div data-value='RE' class="slt-style__option slt-style-C__option" data-mother-id="184">留尼旺 Réunion</div>
    <div data-value='RO' class="slt-style__option slt-style-C__option" data-mother-id="185">羅馬尼亞 Romania</div>
    <div data-value='RS' class="slt-style__option slt-style-C__option" data-mother-id="186">塞爾維亞 Serbia</div>
    <div data-value='RU' class="slt-style__option slt-style-C__option" data-mother-id="187">俄羅斯 Russian Federation</div>
    <div data-value='RW' class="slt-style__option slt-style-C__option" data-mother-id="188">盧安達 Rwanda</div>
    <div data-value='SA' class="slt-style__option slt-style-C__option" data-mother-id="189">沙烏地阿拉伯 Saudi Arabia</div>
    <div data-value='SB' class="slt-style__option slt-style-C__option" data-mother-id="190">索羅門群島 Solomon Islands</div>
    <div data-value='SC' class="slt-style__option slt-style-C__option" data-mother-id="191">塞席爾 Seychelles</div>
    <div data-value='SD' class="slt-style__option slt-style-C__option" data-mother-id="192">蘇丹 Sudan</div>
    <div data-value='SE' class="slt-style__option slt-style-C__option" data-mother-id="193">瑞典 Sweden</div>
    <div data-value='SG' class="slt-style__option slt-style-C__option" data-mother-id="194">新加坡 Singapore</div>
    <div data-value='SH' class="slt-style__option slt-style-C__option" data-mother-id="195">聖赫勒拿 Saint Helena</div>
    <div data-value='SI' class="slt-style__option slt-style-C__option" data-mother-id="196">斯洛維尼亞 Slovenia</div>
    <div data-value='SJ' class="slt-style__option slt-style-C__option" data-mother-id="197">斯瓦爾巴尖棉 Svalbard and Jan Mayen</div>
    <div data-value='SK' class="slt-style__option slt-style-C__option" data-mother-id="198">斯洛伐克 Slovakia</div>
    <div data-value='SL' class="slt-style__option slt-style-C__option" data-mother-id="199">獅子山 Sierra Leone</div>
    <div data-value='SM' class="slt-style__option slt-style-C__option" data-mother-id="200">聖馬利諾 San Marino</div>
    <div data-value='SN' class="slt-style__option slt-style-C__option" data-mother-id="201">塞內加爾 Senegal</div>
    <div data-value='SO' class="slt-style__option slt-style-C__option" data-mother-id="202">索馬利亞 Somalia</div>
    <div data-value='SR' class="slt-style__option slt-style-C__option" data-mother-id="203">蘇利南 Suriname</div>
    <div data-value='ST' class="slt-style__option slt-style-C__option" data-mother-id="204">聖多美普林西比 Sao Tome and Principe</div>
    <div data-value='SV' class="slt-style__option slt-style-C__option" data-mother-id="205">薩爾瓦多 El Salvador</div>
    <div data-value='SY' class="slt-style__option slt-style-C__option" data-mother-id="206">敘利亞 Syrian Arab Republic</div>
    <div data-value='SZ' class="slt-style__option slt-style-C__option" data-mother-id="207">史瓦濟蘭 Swaziland</div>
    <div data-value='TC' class="slt-style__option slt-style-C__option" data-mother-id="208">托克斯寇克斯群島 Turks and Caicos Islands</div>
    <div data-value='TD' class="slt-style__option slt-style-C__option" data-mother-id="209">查德 Chad</div>
    <div data-value='TF' class="slt-style__option slt-style-C__option" data-mother-id="210">法屬南部屬地 French Southern Territories</div>
    <div data-value='TG' class="slt-style__option slt-style-C__option" data-mother-id="211">多哥 Togo</div>
    <div data-value='TH' class="slt-style__option slt-style-C__option" data-mother-id="212">泰國 Thailand</div>
    <div data-value='TJ' class="slt-style__option slt-style-C__option" data-mother-id="213">塔吉克 Tajikistan</div>
    <div data-value='TK' class="slt-style__option slt-style-C__option" data-mother-id="214">托克勞 Tokelau</div>
    <div data-value='TL' class="slt-style__option slt-style-C__option" data-mother-id="215">東帝汶 Timor-Leste</div>
    <div data-value='TM' class="slt-style__option slt-style-C__option" data-mother-id="216">土庫曼 Turkmenistan</div>
    <div data-value='TN' class="slt-style__option slt-style-C__option" data-mother-id="217">突尼西亞 Tunisia</div>
    <div data-value='TO' class="slt-style__option slt-style-C__option" data-mother-id="218">東加 Tonga</div>
    <div data-value='TR' class="slt-style__option slt-style-C__option" data-mother-id="219">土耳其 Turkey</div>
    <div data-value='TT' class="slt-style__option slt-style-C__option" data-mother-id="220">千里達托貝哥 Trinidad and Tobago</div>
    <div data-value='TV' class="slt-style__option slt-style-C__option" data-mother-id="221">吐瓦魯 Tuvalu</div>
    <div data-value='TW' class="slt-style__option slt-style-C__option" data-mother-id="222">台灣 Taiwan (ROC)</div>
    <div data-value='TZ' class="slt-style__option slt-style-C__option" data-mother-id="223">坦尚尼亞 Tanzania</div>
    <div data-value='UA' class="slt-style__option slt-style-C__option" data-mother-id="224">烏克蘭 Ukraine</div>
    <div data-value='UG' class="slt-style__option slt-style-C__option" data-mother-id="225">烏干達 Uganda</div>
    <div data-value='UM' class="slt-style__option slt-style-C__option" data-mother-id="226">美屬邊疆群島 United States Minor Outlying Islands</div>
    <div data-value='US' class="slt-style__option slt-style-C__option" data-mother-id="227">美國 United States</div>
    <div data-value='UY' class="slt-style__option slt-style-C__option" data-mother-id="228">烏拉圭 Uruguay</div>
    <div data-value='UZ' class="slt-style__option slt-style-C__option" data-mother-id="229">烏茲別克 Uzbekistan</div>
    <div data-value='VA' class="slt-style__option slt-style-C__option" data-mother-id="230">教廷(梵蒂岡) Holy See (Vatican City State)</div>
    <div data-value='VC' class="slt-style__option slt-style-C__option" data-mother-id="231">聖文森 Saint Vincent and The Grenadines</div>
    <div data-value='VE' class="slt-style__option slt-style-C__option" data-mother-id="232">委內瑞拉 Venezuela</div>
    <div data-value='VG' class="slt-style__option slt-style-C__option" data-mother-id="233">英屬維爾京群島 Virgin Islands, British</div>
    <div data-value='VI' class="slt-style__option slt-style-C__option" data-mother-id="234">美屬維京群島 Virgin Islands, U.S.</div>
    <div data-value='VN' class="slt-style__option slt-style-C__option" data-mother-id="235">越南 Viet Nam</div>
    <div data-value='VU' class="slt-style__option slt-style-C__option" data-mother-id="236">萬那杜 Vanuatu</div>
    <div data-value='WF' class="slt-style__option slt-style-C__option" data-mother-id="237">華里斯福他納 Wallis and Futuna</div>
    <div data-value='WS' class="slt-style__option slt-style-C__option" data-mother-id="238">薩摩亞 Samoa</div>
    <div data-value='YE' class="slt-style__option slt-style-C__option" data-mother-id="239">葉門 Yemen</div>
    <div data-value='YT' class="slt-style__option slt-style-C__option" data-mother-id="240">美亞特 Mayotte</div>
    <div data-value='ZA' class="slt-style__option slt-style-C__option" data-mother-id="241">南非 South Africa</div>
    <div data-value='ZM' class="slt-style__option slt-style-C__option" data-mother-id="242">尚比亞 Zambia</div>
    <div data-value='ZW' class="slt-style__option slt-style-C__option" data-mother-id="243">辛巴威 Zimbabwe</div>
    `
    $("#js-globalcountry").append(countrylist)
}

function safariHacks() {

    DefineVh = function() {
        let windowsVH = window.innerHeight / 100;
        // console.log(windowsVH)
        document.querySelector('body').style.setProperty('--vh', windowsVH + 'px');
    }
    $(document).ready(function() {
        DefineVh()
            // window.addEventListener('resize', function() {
            //     DefineVh()
            // });
    })

}

function copyrightYear() {
    var today = new Date()
    var year = today.getFullYear()
    $('#copyrightYear').text(year)
}

function counterControl() {

    $('.counter').each(function() {
        var min = $(this).find('.counter__num').attr('min')
        var max = $(this).find('.counter__num').attr('max')
        $(this).find('.counter__plus').click(function() {
            var val = Number($(this).siblings('.counter__num').val())
            if (val < max) {
                $(this).siblings('.counter__num').val(val + 1)
            }
        })
        $(this).find('.counter__minus').click(function() {
            var val = Number($(this).siblings('.counter__num').val())
            if (val > min) {
                $(this).siblings('.counter__num').val(val - 1)
            }
        })
    })

}

function CountUpinit() {
    $('.js-countUpItem').each(function() {
        var dt = $(this).text().trim()
        var countUpItem = new countUp.CountUp(this, dt, {
            duration: 3,
            separator: '',
            decimal: '',
        })
        countUpItem.start()
    })
}

function Textnumber() {
    $('.js-textnumber').each(function() {
        var text = $(this).text()

        if ($(this).text().length > Number($(this).attr('data-textnumber'))) {
            $(this).text(text.substring(0, Number($(this).attr('data-textnumber'))) + '...')
        } else {
            $(this).text(text.substring(0, Number($(this).attr('data-textnumber'))))
        }
        // console.log(Number($(this).attr('data-textnumber')))
    })
}

function Tenpercentile() {
    $('.js-tenpercentile').each(function() {
        $(this).text(AppendComma(parseInt($(this).text().replace(/,/g, ''))))
    })
}


//數字處理為有千分位
function AppendComma(n) {
    // https://kevintsengtw.blogspot.com/2011/10/jquery.html
    if (n < 0) {
        n = '0';
    }
    if (!/^((-*\d+)|(0))$/.test(n)) {
        var newValue = /^((-*\d+)|(0))$/.exec(n);
        if (newValue != null) {
            if (parseInt(newValue, 10)) {
                n = newValue;
            } else {
                n = '0';
            }
        } else {
            n = '0';
        }
    }
    if (parseInt(n, 10) == 0) {
        n = '0';
    } else {
        n = parseInt(n, 10).toString();
    }

    n += '';
    var arr = n.split('.');
    var re = /(\d{1,3})(?=(\d{3})+$)/g;
    // console.log(arr[0].replace(re, '$1,') + (arr.length == 2 ? '.' + arr[1] : ''))
    return arr[0].replace(re, '$1,') + (arr.length == 2 ? '.' + arr[1] : '');
}

function CommonDateFunc() {
    $('.js-month').each(function() {
        var num = $(this).text().replace(/^0+/, '');
        switch (num) {
            case '1':
                $(this).text('January')
                break
            case '2':
                $(this).text('February')
                break
            case '3':
                $(this).text('March')
                break
            case '4':
                $(this).text('April')
                break
            case '5':
                $(this).text('May')
                break
            case '6':
                $(this).text('June')
                break
            case '7':
                $(this).text('July')
                break
            case '8':
                $(this).text('August')
                break
            case '9':
                $(this).text('September')
                break
            case '10':
                $(this).text('October')
                break
            case '11':
                $(this).text('November')
                break
            case '12':
                $(this).text('December')
                break
        }
    })
    $('.js-day').each(function() {
        $(this).text($(this).text().padStart(2, '0'))
    })
}

function NavbarCurrentPageStyle() {

    if ($currentpage == "PRODUCTSDETAIL") {
        var page = 'PRODUCTS'
    } else {
        var page = $currentpage
    }
    $('.navhead[data-page="' + page + '"]').addClass('navhead--current')
}


function dropdownControl() {

    // 使用.js-dropdown>(.js-dropdown__head+.js-dropdown__body)
    // 可對.js-dropdown賦予以下attribute:
    // [data-dropdown-individual="true"],達到不與其他同層的.js-dropdown連動
    // [data-dropdown-open="true"],預設為開 
    // [data-dropdown-persistent="true"],一但點開後除非點其他項目，否則不會關

    $('.js-dropdown').each(function() {
        if ($(this).attr('data-dropdown-open') == 'true') {
            $(this).find('.js-dropdown__body').show()
            $(this).find('.js-dropdown__head').addClass('js-dropdown__head--active')
        } else {
            $(this).find('.js-dropdown__body').hide()
        }
    })

    $('.js-dropdown__head').click(function() {
        if ($(this).closest('.js-dropdown').attr('data-dropdown-persistent') == "true" && $(this).hasClass('js-dropdown__head--active')) {
            return
        }
        $(this).toggleClass('js-dropdown__head--active')
        $(this).closest('.js-dropdown').children('.js-dropdown__body').slideToggle()
        if ($(this).closest('.js-dropdown').attr('data-dropdown-individual') == "true") {} else {
            $(this).closest('.js-dropdown').siblings('.js-dropdown').find('.js-dropdown__head').removeClass('js-dropdown__head--active')
            $(this).closest('.js-dropdown').siblings('.js-dropdown').find('.js-dropdown__body').slideUp()
        }
    })

    // proitem樣式補丁
    $('.proitem').each(function() { 
        if($(this).hasClass('proitem--current')){
            $(this).find('.js-dropdown__head').trigger('click')
        }
        else{
            if ($(this).find('.subProitem--current').length > 0) {
                $(this).find('.js-dropdown__head').trigger('click')
                $(this).addClass('proitem--current')
            } else {
            }
        }
    })
}

function bubbleBtn(targetClass, targetHoverClass, targetBubbleClass) {

    if ($('.' + targetClass).length > 0) {
        $('.' + targetClass).mouseenter(function(event) {
            if ($(this).hasClass(targetHoverClass)) {} else {
                var item_top = $(this).offset().top
                var item_left = $(this).offset().left
                $(this).find('.' + targetBubbleClass).css({ 'top': Math.abs(item_top - event.pageY), 'left': Math.abs(item_left - event.pageX) })
                setTimeout(() => {
                    $(this).addClass(targetHoverClass)
                }, 10)
            }
        })

        $('.' + targetClass).mouseleave(function(event) {
            var item_top = $(this).offset().top
            var item_left = $(this).offset().left
            $(this).find('.' + targetBubbleClass).css({ 'top': Math.abs(item_top - event.pageY), 'left': Math.abs(item_left - event.pageX) })
            $(this).removeClass(targetHoverClass)
        })
    }

}

function socialShareButtonControl() {

    var webUrl = window.location.href
    var webTitle = document.title

    $('#socialShare-Line').click(function() {
        window.open('http://line.naver.jp/R/msg/text/?' + webUrl, '_blank', 'left=500,top=200,width=700,height=500,toolbar=1,resizable=0');

    })
    $('#socialShare-FB').click(function() {
        window.open('https://www.facebook.com/sharer.php?u=' + webUrl, '_blank', '');

    })
    $('#socialShare-X').click(function() {
        window.open('https://twitter.com/share?text=' + webTitle + '&url=' + webUrl, '_blank', '');

    })
    $('#socialShare-LinkedIn').click(function() {
        window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + webUrl + '&title=' + webTitle, '_blank', '');

    })
    $('#socialShare-Whatsapp').click(function() {
        window.open('https://api.whatsapp.com/send?text=' + webTitle + ': ' + webUrl);

    })
    $('#socialShare-CopyLink').append(`
        <textarea style="width:1px;height:1px;opacity:0;z-index:-999">${webUrl}</textarea>
    `)
    $('#socialShare-CopyLink').click(function() {
        $(this).find('textarea').select()
        document.execCommand('Copy');
        alert('複製網址成功');
    })

}

if ($currentpage != "GUIDELINE") {
    // 點擊a連擊滾動頁面
    $("a").on('click', function(event) {
        /* Make sure this.hash has a value before overriding default behavior */
        if (this.hash !== "" && this.hash !== "#!") {
            /* Prevent default anchor click behavior */
            event.preventDefault();
            /* Store hash */
            var hash = this.hash;
            /* Using jQuery's animate() method to add smooth page scroll*/
            /* The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area*/
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function() {
                /* Add hash (#) to URL when done scrolling (default click behavior)*/
                window.location.hash = hash;
            });
        } /* End if */
    });
}

function productboxIndexBorderAnimation() {
    const productboxIndex = document.querySelectorAll('.productbox-index')
    productboxIndex.forEach(item => {
        let currentAngle = 0;
        let targetAngle = 0;
        let rafId = null;

        item.addEventListener('mouseenter', (e) => {
            // 滑鼠剛進入時，先計算一次精準角度，避免從0度硬轉過去
            const rect = item.getBoundingClientRect()
            const x = e.clientX - rect.left - rect.width / 2
            const y = e.clientY - rect.top - rect.height / 2
            targetAngle = currentAngle = Math.atan2(y, x) * 180 / Math.PI + 180
            item.style.setProperty('--angle', currentAngle)

            // 開始執行平滑過渡動畫
            function update() {
                // 使用 Lerp (線性插值) 讓角度滑順跟隨，0.1 越小越平滑
                currentAngle += (targetAngle - currentAngle) * 0.1
                item.style.setProperty('--angle', currentAngle)
                rafId = requestAnimationFrame(update)
            }
            cancelAnimationFrame(rafId)
            update()
        })

        item.addEventListener('mousemove', (e) => {
            const rect = item.getBoundingClientRect()
            const x = e.clientX - rect.left - rect.width / 2
            const y = e.clientY - rect.top - rect.height / 2

            let angle = Math.atan2(y, x) * 180 / Math.PI + 180

            // 處理角度跨越邊界 (例如 270度跳到 -90度) 的突變，確保它總是走「最短的旋轉路徑」
            let diff = angle - targetAngle
            diff = ((diff + 180) % 360 + 360) % 360 - 180
            targetAngle += diff
        })

        item.addEventListener('mouseleave', () => {
            // 滑鼠離開時停止計算，節省效能
            cancelAnimationFrame(rafId)
        })
    })
}

// 聯絡我們／詢問車必填欄位驗證：擋送出 + alert + 個別欄位 errmsg
document.addEventListener('DOMContentLoaded', function () {
    var forms = new Set();
    document.querySelectorAll('.form-contact, .form-contact2').forEach(function (el) {
        var form = el.tagName === 'FORM' ? el : el.closest('form');
        if (form) forms.add(form);
    });

    forms.forEach(function (form) {
        form.setAttribute('novalidate', 'novalidate');

        function getErrmsg(field) {
            return field.parentElement && field.parentElement.querySelector('.form-contact2__errmsg, .form-contact__errmsg');
        }

        form.querySelectorAll('[required]').forEach(function (field) {
            field.addEventListener('input', function () {
                if (field.value.trim()) {
                    var errmsg = getErrmsg(field);
                    if (errmsg) errmsg.textContent = '';
                }
            });
        });

        form.addEventListener('submit', function (e) {
            var invalidFields = [];
            form.querySelectorAll('[required]').forEach(function (field) {
                var errmsg = getErrmsg(field);
                if (!field.value.trim()) {
                    invalidFields.push(field);
                    if (errmsg) errmsg.textContent = field.dataset.requiredMsg || '此欄位為必填';
                } else if (errmsg) {
                    errmsg.textContent = '';
                }
            });

            if (invalidFields.length > 0) {
                e.preventDefault();
                alert('請完整填寫必填欄位');
                invalidFields[0].focus();
            }
        });
    });
});